import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Componentes
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import ItemList from '../../components/ItemList/ItemList';
import FriendlyPhrase from '../../components/FriendlyPhrase/FriendlyPhrase';

// Contextos
import { useToast } from '../../contexts/ToastContext';
import { useLoader } from '../../contexts/LoaderContext';
import { useModal } from '../../contexts/ModalContext';

// Estilos
import styles from './produtospage.module.css';

// API
import { useProdutoService } from '../../services/produtoService';

function ProdutosPage() {
    const navigate = useNavigate();

    const { showToast } = useToast();
    const { showModal } = useModal();
    const { showLoader, hideLoader } = useLoader();

    const { listarProdutos, deletarProduto } = useProdutoService();
    const [produtos, setProdutos] = useState([]);

    useEffect(() => {
        const carregarProdutos = async () => {
            showLoader("Carregando produtos");

            try {
                const response = await listarProdutos();

                if (response.success && Array.isArray(response.data)) {
                    const dadosTratados = response.data.map(produto => ({
                        id: produto.id,
                        name: produto.nome,
                        raw: produto,
                    }));
                    setProdutos(dadosTratados);
                } else {
                    console.error("Resposta inesperada da API:", response);
                    showToast("Erro ao carregar produtos (dados ausentes ou inválidos).", 4000, "error");
                }
            } catch (erro) {
                console.error("Erro ao buscar produtos:", erro);
                showToast("Erro inesperado ao carregar produtos.", 4000, "error");
            }

            hideLoader();
        };

        carregarProdutos();
    }, []);

    const handleEditar = (item) => {
        navigate(`/produtos/atualizar/${item.id}`);
    };

    const handleExcluir = (item) => {
        showModal(
            `Excluir ${item.name}?`,
            'Todos os testes e usuários perderão esse produto.',
            async () => {
                showLoader("Excluindo produto");

                const response = await deletarProduto(item.id);

                if (response.success) {
                    setProdutos((prev) => prev.filter((p) => p.id !== item.id));
                    showToast('Produto excluído com sucesso!', 3000, 'success');
                } else {
                    showToast('Erro ao excluir produto.', 3000, 'error');
                    console.error(response.message);
                }

                hideLoader();
            },
            () => {
                showToast('Exclusão cancelada.', 2000);
            }
        );
    };

    const handleAdd = () => {
        navigate(`/produtos/adicionarProduto`);
    };

    const handleSelecionar = (item) => {
        console.log("Produto selecionado:", item);
    };

    return (
        <div className={styles.ProdutosPage}>
            <div className={styles.containerTop}>
                <Breadcrumbs />

                <h1 className={styles.title}>
                    Produtos Cadastrados
                </h1>

                <FriendlyPhrase page="produtos" />
            </div>

            <div className={styles.containerList}>
                <ItemList
                    items={produtos}
                    onAdd={handleAdd}
                    onEdit={handleEditar}
                    onDelete={handleExcluir}
                    onClickItem={handleSelecionar}
                />
            </div>
        </div>
    );
}

export default ProdutosPage;